import { render, staticRenderFns } from "./ttfopenaccount.vue?vue&type=template&id=ebc77fd2&scoped=true&"
import script from "./ttfopenaccount.vue?vue&type=script&lang=js&"
export * from "./ttfopenaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc77fd2",
  null
  
)

export default component.exports